import React from 'react'
import { IconProps } from './icons.models'

export const MessageIcon: React.FC<IconProps> = ({
    width = 14,
    height = 13,
    fillColor = '#155DFC',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.2682 0.599609H1.9349C1.58127 0.599609 1.24214 0.740085 0.992087 0.990134C0.742038 1.24018 0.601563 1.57932 0.601562 1.93294V11.9329L2.9129 10.1996C3.14369 10.0265 3.4244 9.93294 3.7129 9.93294H11.2682C11.6219 9.93294 11.961 9.79247 12.211 9.54242C12.4611 9.29237 12.6016 8.95323 12.6016 8.59961V1.93294C12.6016 1.57932 12.4611 1.24018 12.211 0.990134C11.961 0.740085 11.6219 0.599609 11.2682 0.599609Z" stroke={fillColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
